import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
} from "@mui/material";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import DatePicker from '@mui/lab/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DropZone from "../DropZone";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { useFormik } from 'formik';
import * as yup from 'yup';
import workloadAndPerformanceService from "../../services/workloadAndPerformance.service";


const useStyles = makeStyles({
  dateTimePicker: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
    position: "relative",
    marginBottom: "14px !important",
    '& div > .MuiOutlinedInput-root': {
      height: "40px !important",
      marginTop: "10px"
    },
    '& div > .MuiOutlinedInput-root > input': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& div > .MuiOutlinedInput-root > div > button': {
      width: "100%",
      position: "absolute",
      left: "0",
      justifyContent: "flex-end",
      height: "100%",
      borderRadius: "0",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "& > span": {
        display: "none"
      }
    },
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  dateTimePickerDis: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
    position: "relative",
    marginBottom: "14px !important",
    "&  > div > div ": {
      backgroundColor: "#F5F5F5 !important",
    },
    '& div > .MuiOutlinedInput-root': {
      marginTop: "10px",
      height: "40px !important",
    },
    '& div > .MuiOutlinedInput-root > input': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& div > .MuiOutlinedInput-root > div > button': {
      width: "100%",
      position: "absolute",
      left: "0",
      justifyContent: "flex-end",
      height: "100%",
      borderRadius: "0",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "& > span": {
        display: "none"
      }
    },
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  error: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
    position: "relative",
    marginBottom: "14px !important",
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  errorDis: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
    position: "relative",
    marginBottom: "14px !important",
    "&  > div > div ": {
      backgroundColor: "#F5F5F5 !important",
    },
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  radio: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
    position: "relative",
    marginBottom: "14px !important",
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  remark: {
    "&  > div > div ": {
      backgroundColor: "#F5F5F5 !important",
    },
  },
  footer: {
    position: "sticky",
    bottom: "-20px",
    background: "white",
    marginTop: "0 !important",
    paddingRight: "24px",
    paddingBottom: "15px",
    paddingTop: "20px",
  },
});

const CustomForm = (props) => {
  const { serial } = props;
  const [data, setData] = React.useState([]);
  const [valueOfData, setValueOfData] = React.useState([]);
  const [defaultValue, setDefualtValue] = React.useState([]);
  const [unit, setUnit] = React.useState();
  const [dataInitFormik, setDataInitFormik] = React.useState({});
  const [dataErrorFormik, setdataErrorFormik] = React.useState({});
  const classes = useStyles()
  const validationSchema = yup.object(dataErrorFormik);
  const formik = useFormik({
    initialValues: dataInitFormik,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.submit(values, unit)
    },
  });
  const handleSubmit = () => {
    formik.submitForm()
  }
  const formatDate = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  const selectField = (field) => (event) => {
    // setValueWorkType(event.target.value);
    // formik.values.workTypeSelected = event.target.value
    formik.setFieldValue(field, event.target.value)
  };
  const selectDate = (field, data, type) => {
    if (type === "date") {
      formik.setFieldValue(field, formatDate(data))
    } else {
      formik.setFieldValue(field, data)
    }
  };
  useEffect(() => {
    getDataForm()
  }, []);
  useEffect(() => {
    if (data?.length > 0) {
      let setRemark = defaultValue.find((res) => res.name === "remark")
      let init = { remark: setRemark?.value !== undefined && setRemark?.value !== null ? setRemark?.value : "" }
      let error = {
        remark: yup.string()
      }
      for (let index = 0; index <= data.length - 1; index++) {
        let val = defaultValue.find((res) => res.name === data[index].key)
        if (data[index].type === "datepickers") {
          init[data[index].key] = val?.value !== undefined && val?.value !== null ? val?.value : null
        } else if (unit?.name === data[index].key) {
          init[data[index].key] = unit?.value !== undefined && unit?.value !== null ? unit?.value : ""
        } else {
          init[data[index].key] = val?.value !== undefined && val?.value !== null ? val?.value : ""
        }
        if (data[index].required === true) {
          if (data[index].validator !== null) {
            if (data[index].type === "number") {
              if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "" &&
                data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                error[data[index].key] = yup.number().min(data[index].validator?.min, data[index].validator?.message).max(data[index].validator?.max, data[index].validator?.message).required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
              } else {
                if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "" && data[index].validator?.min > 0) {
                  error[data[index].key] = yup.number().min(data[index].validator?.min, data[index].validator?.message).required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
                } else if (data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                  error[data[index].key] = yup.number().max(data[index].validator?.max, data[index].validator?.message).required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
                } else {
                  error[data[index].key] = yup.number().required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
                }

              }
            } else {
              if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "" &&
                data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                error[data[index].key] = yup.string().min(data[index].validator?.min, data[index].validator?.message).max(data[index].validator?.max, data[index].validator?.message).required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
              } else {
                if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "") {
                  error[data[index].key] = yup.string().min(data[index].validator?.min, data[index].validator?.message).required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
                } else if (data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                  error[data[index].key] = yup.string().max(data[index].validator?.max, data[index].validator?.message).required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
                } else {
                  error[data[index].key] = yup.string().required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
                }
              }
            }
          } else {
            error[data[index].key] = yup.string().required(`กรุณาระบุข้อมูล ${data[index].field}`).nullable()
          }
        } else {
          if (data[index].validator !== null) {
            if (data[index].type === "number") {
              if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "" &&
                data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                error[data[index].key] = yup.number().min(data[index].validator?.min, data[index].validator?.message).max(data[index].validator?.max, data[index].validator?.message).nullable()
              } else {
                if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "" && data[index].validator?.min > 0) {
                  error[data[index].key] = yup.number().min(data[index].validator?.min, data[index].validator?.message).nullable()
                } else if (data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                  error[data[index].key] = yup.number().max(data[index].validator?.max, data[index].validator?.message).nullable()
                } else {
                  error[data[index].key] = yup.number().nullable()
                }

              }
            } else {
              if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "" &&
                data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                error[data[index].key] = yup.string().min(data[index].validator?.min, data[index].validator?.message).max(data[index].validator?.max, data[index].validator?.message).nullable()
              } else {
                if (data[index].validator?.min !== undefined && data[index].validator?.min !== null && data[index].validator?.min !== "") {
                  error[data[index].key] = yup.string().min(data[index].validator?.min, data[index].validator?.message).nullable()
                } else if (data[index].validator?.max !== undefined && data[index].validator?.max !== null && data[index].validator?.max !== "") {
                  error[data[index].key] = yup.string().max(data[index].validator?.max, data[index].validator?.message).nullable()
                } else {
                  error[data[index].key] = yup.string().nullable()
                }
              }
            }
          } else {
            error[data[index].key] = yup.string().nullable()
          }
        }
      }
      setdataErrorFormik(error)
      setDataInitFormik(init)
    }
  }, [data]);
  const getDataForm = () => {
    if (props.item.id !== undefined && props.item.id !== null && props.item.id !== "") {
      workloadAndPerformanceService.getForm(serial, props.item.id).then(
        (response) => {
          setUnit(response.academic_unit)
          setValueOfData(response.value)
          setDefualtValue(response.default)
          setData(response.data);
        },
      );
    } else {
      workloadAndPerformanceService.getForm(serial).then(
        (response) => {
          setUnit(response.academic_unit)
          setData(response.data);
          setValueOfData(response.value)
        },
      );
    }
  }
  const Form = (index) => {
    if (data?.length > 0) {
      let dtForm = data.filter(item => item.row === index)
      if (dtForm.length > 0) {
        dtForm.sort(function (a, b) {
          if (a.column < b.column) {
            return -1;
          } else if (a.column > b.column) {
            return 1;
          } else {
            return 0;
          }
        });
        return (
          <Grid container mt={2} spacing={3}>
            {
              dtForm.map((item, k) => {
                let val = valueOfData.filter(dt => dt.code === item.key)
                if (item.type === "select") {
                  return (
                    <Grid item md={12 / item.layout} xs={12} sx={{ paddingTop: "0 !important" }} classes={{ root: item.edit === false ? classes.errorDis : classes.error }}>
                      <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{item.field} {item.required === true ? <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box> : null}</Typography>
                      {item.hint !== undefined && item.hint !== null ? <Typography variant="subtitle1" fontSize={13} lineHeight="14px" color="#A0A0A0">{item.hint}</Typography> : null}
                      <Select
                        id={`${item.key}`}
                        variant="outlined"
                        defaultValue=""
                        displayEmpty
                        size="small"
                        placeholder={item.placeholder}
                        fullWidth
                        disabled={item.edit === false ? true : false}
                        className="white-bg"
                        value={formik.values[item.key]}
                        onChange={selectField(`${item.key}`)}
                        sx={Boolean(formik.touched[item.key] && formik.errors[item.key]) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
                      >
                        <MenuItem disabled value="">
                          <Typography variant="sub_label" style={{ fontWeight: "300" }}>{item.placeholder}</Typography>
                        </MenuItem>
                        {
                          val?.length > 0 ?
                            val.map(vl => {
                              return (
                                vl?.value?.length > 0 ?
                                  vl.value.map(chVl => {
                                    return (
                                      <MenuItem value={chVl.serial} key={chVl.code}>
                                        {chVl.name}
                                      </MenuItem>
                                    )
                                  })
                                  : null
                              )
                            })
                            : <MenuItem value="">
                              ไม่พบข้อมูล
                            </MenuItem>
                        }
                      </Select>
                      {formik.touched[item.key] && formik.errors[item.key] ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors[item.key]} </FormHelperText>) : <></>}
                    </Grid>
                  )
                } else if (item.type === "text") {
                  return (
                    <Grid item md={12 / item.layout} xs={12} sx={{ paddingTop: "0 !important" }} classes={{ root: item.edit === false ? classes.errorDis : classes.error }}>
                      <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{item.field} {item.required === true ? <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box> : null}</Typography>
                      {item.hint !== undefined && item.hint !== null ? <Typography variant="subtitle1" fontSize={13} lineHeight="14px" color="#A0A0A0">{item.hint}</Typography> : null}
                      <TextField
                        margin="dense"
                        placeholder={item.placeholder}
                        id="field_9"
                        fullWidth
                        size="small"
                        disabled={item.edit === false ? true : false}
                        sx={{ marginTop: "10px", marginBottom: 0 }}
                        value={formik.values[item.key]}
                        onChange={(newValue) => {
                          selectDate(item.key, newValue.target.value);
                        }}
                        helperText={formik.touched[item.key] && formik.errors[item.key]}
                        error={Boolean(formik.touched[item.key] && formik.errors[item.key])}
                      />
                    </Grid>
                  )
                } else if (item.type === "number") {
                  return (
                    <Grid item md={12 / item.layout} xs={12} sx={{ paddingTop: "0 !important" }} classes={{ root: item.edit === false ? classes.errorDis : classes.error }}>
                      <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{item.field} {item.required === true ? <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box> : null}</Typography>
                      {item.hint !== undefined && item.hint !== null ? <Typography variant="subtitle1" fontSize={13} lineHeight="14px" color="#A0A0A0">{item.hint}</Typography> : null}
                      <TextField
                        margin="dense"
                        placeholder={item.placeholder}
                        id="field_9"
                        fullWidth
                        disabled={item.edit === false ? true : false}
                        size="small"
                        sx={{ marginTop: "10px", marginBottom: 0 }}
                        value={formik.values[item.key]}
                        onChange={(newValue) => {
                          selectDate(item.key, newValue.target.value.replaceAll(/[^0-9]/g, ''));
                        }}
                        helperText={formik.touched[item.key] && formik.errors[item.key]}
                        error={Boolean(formik.touched[item.key] && formik.errors[item.key])}
                      />
                    </Grid>
                  )
                } else if (item.type === "radio") {
                  return (
                    <Grid item md={12 / item.layout} xs={12} sx={{ paddingTop: "0 !important", }} classes={{ root: classes.radio }}>
                      <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{item.field} {item.required === true ? <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box> : null}</Typography>
                      {item.hint !== undefined && item.hint !== null ? <Typography variant="subtitle1" fontSize={13} lineHeight="14px" color="#A0A0A0">{item.hint}</Typography> : null}
                      <FormControl component="fieldset" sx={{ marginBottom: 0, height: "40px", marginTop: "10px" }}>
                        <RadioGroup row aria-label="gender" name="row-radio-buttons-group"
                          value={formik.values[item.key]}
                          onChange={(newValue) => {
                            selectDate(item.key, newValue.target.value);
                          }}
                        >
                          {
                            val?.length > 0 ?
                              val.map(vl => {
                                return (
                                  vl?.value?.length > 0 ?
                                    vl.value.map(chVl => {
                                      return (
                                        <FormControlLabel disabled={item.edit === false ? true : false} value={chVl.serial} control={<Radio />} label={chVl.name} sx={{ margintop: 0, marginBottom: 0 }} />
                                      )
                                    })
                                    : null
                                )
                              })
                              : <MenuItem value="">
                                ไม่พบข้อมูล
                              </MenuItem>
                          }
                        </RadioGroup>
                      </FormControl>
                      {formik.touched[item.key] && formik.errors[item.key] ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors[item.key]} </FormHelperText>) : <></>}
                    </Grid>
                  )
                } else if (item.type === "datepickers") {
                  return (
                    <Grid item md={12 / item.layout} xs={12} sx={{ paddingTop: "0 !important" }} classes={{ root: item.hint !== undefined && item.hint !== null ? item.edit === false ? classes.dateTimePickerDis : classes.dateTimePicker : item.edit === false ? classes.dateTimePickerDis : classes.dateTimePicker }}>
                      <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{item.field} {item.required === true ? <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box> : null}</Typography>
                      {item.hint !== undefined && item.hint !== null ? <Typography variant="subtitle1" fontSize={13} lineHeight="14px" color="#A0A0A0">{item.hint}</Typography> : null}
                      <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <DatePicker
                          format="yyyy/MM/dd"
                          value={formik.values[item.key]}
                          disabled={item.edit === false ? true : false}
                          onChange={(newValue) => {
                            selectDate(item.key, newValue, "date");
                          }}
                          minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                          maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                          inputProps={{ placeholder: item.placeholder }}
                          renderInput={(params) => <TextField {...params}
                            fullWidth
                          />
                          }
                        />
                      </LocalizationProvider>
                      {formik.touched[item.key] && formik.errors[item.key] ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors[item.key]} </FormHelperText>) : <></>}
                    </Grid>
                  )
                }
              })
            }
          </Grid >
        )
      }
    }
  }
  const styles = {
    link: {
      color: "#5DA196",
      fontWeight: 300
    }
  }
  return (
    <React.Fragment>
      <Box padding={3} >
        <Grid container>
          <Grid item md sx={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h3">{props.item.id !== undefined && props.item.id !== null && props.item.id !== "" ? "แก้ไข" : "เพิ่ม"}ภาระงานและผลงาน <span style={styles.link}>(2/2)</span></Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography variant="h4">รายละเอียดภาระงานและผลงาน</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography variant="sub_label">{props?.subTitle}</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography variant="h4">หน่วยปริมาณงาน</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography variant="sub_label">{unit?.description !== undefined && unit?.description !== null && unit?.description !== "" ? unit.description : "-"}</Typography>
          </Grid>
        </Grid>
        {
          data?.length > 0 && Object.keys(formik.values).length > 0 ?
            data.map((item, k) => {
              return (
                Form(k)
              )
            }) : null
        }
        <Grid container mt={2}>
          <Grid item>
            <Typography variant="subtitle1" display="flex">หมายเหตุ</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={12} xs={12} classes={{ root: props.item.isManual !== undefined && props.item.isManual !== null && props.item.isManual !== "" ? props.item.isManual === true ? null : classes.remark : null }}>
            <TextField
              margin="dense"
              id="note"
              placeholder="เขียนหมายเหตุ"
              fullWidth
              multiline
              disabled={props.item.isManual !== undefined && props.item.isManual !== null && props.item.isManual !== "" ? props.item.isManual === true ? false : true : false}
              rows={6}
              size="small"
              value={formik.values.remark}
              onChange={(newValue) => {
                selectDate("remark", newValue.target.value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Grid container mt={3} mb={0} classes={{ root: classes.footer }}>
        <Grid item xs display="flex" flexDirection="row-reverse" >
          <Box sx={{ width: "100px" }}>
            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
              {props.item.id !== undefined && props.item.id !== null && props.item.id !== "" ? "บันทึก" : "เพิ่ม"}
            </Button>
          </Box>
          <Box sx={{ width: "100px" }} mr={2}>
            {/* {props.item.id !== undefined && props.item.id !== null && props.item.id !== "" ?
              <Button onClick={props.close} color="black" variant="outlined" fullWidth>
                ย้อนกลับ
              </Button>
              : null} */}
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
export default CustomForm;
